/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>0 - UsersMessage</b>: Пользовательское сообщение</li>\n<li><b>1 - SystemMessage</b>: Системное сообщение</li>\n</ul>\n
 */
export const chatMessageTypeEnumSchema = z.union([z.literal(0), z.literal(1)]).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - UsersMessage</b>: Пользовательское сообщение</li>\n<li><b>1 - SystemMessage</b>: Системное сообщение</li>\n</ul>\n")